import { Link } from 'react-router-dom';
import './style.css';


const Skill = ({ title_skill, capacity_1, capacity_2, capacity_3, capacity_4, cta, link}) => {
  return ( 
      <div className="skill__card">

        <h2 className="skill__card-title">{title_skill}</h2>
        <ul className="skill__card-bullets flow">
          <li>{capacity_1}</li>
          <li>{capacity_2}</li>
          <li>{capacity_3}</li>
          <li>{capacity_4}</li>
        </ul>
        <Link to={link} className='skill__card-cta'>{cta}</Link>
      </div>
  );
}
 
export default Skill;